module.exports = __webpack_public_path__ + "static/media/loader.769aad6f.svg";